module.exports = __webpack_public_path__ + "assets/img/s2_tab2_m.0523db46.png";